module.exports = __webpack_public_path__ + "static/media/plus_green.49719c49.svg";